
import { EmployeeDto } from "src/dtos/employee/employeeDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface SYS3050_R01Dto extends EmployeeDto {
	inserted: boolean;
	isModified: boolean;
}



//기본 인터페이스스
export const defaultSYS3050_R01Dto: SYS3050_R01Dto = {
    valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
    empNo: '',
    empNm: '',
    ename: '',
    cname: '',
    compCd: '',
    resnoBirth: '',
    resnoLastkey: '',
    orgCd: '',
    cardNo: '',
    empSts: '',
    workArea: '',
    empDt: formatDate(new Date()),
    compJoinType: '',
    retireDt: '9999-12-31',
    retireType: '',
    positionCd: '',
    jobClass: '',
    jobPosition: '',
    positionDt: formatDate(new Date()),
    siteWorkYn: '',
    payType: '',
    baseAddress: '',
    post: '',
    address: '',
    detailAddress: '',
    otherAddress: '',
    addressFull: '',
    birthdayType: '',
    birthday: formatDate(new Date()),
    weddingYn: '',
    weddingDt: formatDate(new Date()),
    educationLevel: '',
    educationNm: '',
    telNo: '',
    mobileNo: '',
    email: '',
    meritPersonYn: '',
    carType: '',
    carNm: '',
    carNo: '',
    yearVacationDt: formatDate(new Date()),
    retireInterimDt: formatDate(new Date()),
    country: '',
    officeTel: '',
    officeFax: '',
    foreignYn: '',
    remark: '',

	inserted: false,
	isModified: false,

    insertDt: new Date(),
    insertUser: '',
    insertForm: '',
    updateDt: new Date(),
    updateUser: '',
    updateForm: ''
}
